import { useEffect, useState, useCallback, useRef } from "react";

// Countdown Timer Hook
export const useCountdown = (targetDate) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const targetDateRef = useRef(targetDate);

  // Update ref when targetDate changes
  useEffect(() => {
    targetDateRef.current = targetDate;
  }, [targetDate]);

  useEffect(() => {
    const calculateAndSetTimeLeft = () => {
      const target = targetDateRef.current;
      const difference = target - new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateAndSetTimeLeft();
    const timer = setInterval(calculateAndSetTimeLeft, 1000);
    
    return () => clearInterval(timer);
  }, []);

  return timeLeft;
};

// Countdown até meia-noite Hook
export const useMidnightCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateAndSetTimeLeft = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const difference = midnight - now;
      
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateAndSetTimeLeft();
    const timer = setInterval(calculateAndSetTimeLeft, 1000);
    
    return () => clearInterval(timer);
  }, []);

  return timeLeft;
};

export default useCountdown;
